import { Time } from "./Time";
import { Vector } from "./Vector";
import { Matrix } from "./Matrix";
import { Earth } from "./Earth";
import { Sun } from "./Sun";
import * as Constants from "./Constants";
import * as satellite from 'satellite.js';

export class Sgp4Orbit {

    _tle: string;
    private _satrec: any;

    constructor(tle: string) {
        let tleLine1 = tle.substr(0, 69);
        let tleLine2 = tle.substr(69, 69);
        this._tle = tleLine1 + tleLine2;
        this._satrec = satellite.twoline2satrec(tleLine1, tleLine2);
    }

    getLatLng(time: number): number[] {
        // get the current position of the satellite in Earth centered inertial coordinates
        let positionAndVelocity = satellite.propagate(this._satrec, new Date(time));
        let satPosEci = positionAndVelocity.position;

        // get the Greenwich mean sidereal time (rotation angle of Earth)
        let gmst = satellite.gstime(new Date(time));

        // get the geodetic position of the satellite
        let satPosGd = satellite.eciToGeodetic(satPosEci, gmst);
        var lat = satPosGd.latitude * Constants.RADTODEG;
        var lng = satPosGd.longitude * Constants.RADTODEG;
        if (lng < -180)
            lng += 360
        if (lng > 180)
            lng -= 360

        return [lat, lng];
    }

    /** Gets the geodetic height in km */
    getHeight(time: number): number {
        let positionAndVelocity = satellite.propagate(this._satrec, new Date(time));
        let satPosEci = positionAndVelocity.position;

        // get the geodetic position of the satellite
        let satPosGd = satellite.eciToGeodetic(satPosEci, 0);

        return satPosGd.height;
    }

    /** Gets the orbital period in milliseconds */
    get period(): number {
        let orbitsPerDay = Number(this._tle.substr(121, 11));
        return Time.TICKS_PER_DAY / orbitsPerDay;
    }

    /** Gets the geocentric position in inertial coordinates */
    getPos(t: number): Vector {
        let positionAndVelocity = satellite.propagate(this._satrec, new Date(t));
        let pos = positionAndVelocity.position;
        return new Vector(pos.x, pos.y, pos.z);
    }

    /** Is the satellite sunlit at the given time? */
    isSunlit(t: number): boolean {
        let pos = this.getPos(t);

        let sunPos = Sun.getRoughPos(t);
        let angleToSun = pos.angleBetween(sunPos);

        // Is the spacecraft in sunlight ?
        let rSat = pos.magnitude;
        let angleLimit = Constants.HALFPI + Math.acos(Earth.RADIUS / rSat);

        return (angleToSun < angleLimit);
    }

    /** Find the time of the next sunrise or sunset, from the given start time, up to the maximum look-ahead time */
    findNextSunRiseSet(startTime: number, maxLookAhead: number): number {

        // use a time step of 30 seconds.
        // Note: this will mean shorter periods of lighting change will be missed. This algorithm should be improved in the future to detect peaks 
        // and troughs in the sun elevation
        let dt = 30000;

        let t = startTime;
        let endTime = startTime + maxLookAhead;
        let inSunlight = this.isSunlit(t);
        while (t < endTime) {
            if (this.isSunlit(t) != inSunlight) {
                // we have found a change in lighting condition
                return t;
            }
            t += dt;
        }
        return NaN;
    }
}



// WEBPACK FOOTER //
// ./src/Sgp4Orbit.ts